import { z } from "zod";

const NonNegativeDecimalStringSchema = z
  .string()
  .regex(/^(?:\d+(?:\.\d*)?|\.\d+)$/, "Must be a non-negative decimal number");

const NonNegativeIntSchema = z.number().int().min(0);

/** Pre-Forgepoint baselines and target users an operator sets for one organization. Null means not set. */
export const UpdateCustomerHealthBaselinesRequestSchema = z.object({
  accountType: z.enum(["CUSTOMER", "INTERNAL_TEST"]).default("CUSTOMER"),
  winRate: z.number().min(0).max(1).nullable().default(null),
  businessHoursToQuote: NonNegativeDecimalStringSchema.nullable(),
  monthlyQuoteVolume: NonNegativeIntSchema.nullable(),
  annualRevenue: NonNegativeDecimalStringSchema.nullable(),
  contractedSeats: NonNegativeIntSchema.nullable(),
  quoteEditsPerQuote: NonNegativeDecimalStringSchema.nullable(),
  targetEstimatorUserIds: z.array(z.string().min(1)),
  targetExecUserIds: z.array(z.string().min(1)),
  targetSalesRepUserIds: z.array(z.string().min(1)),
});

export type UpdateCustomerHealthBaselinesRequest = z.infer<
  typeof UpdateCustomerHealthBaselinesRequestSchema
>;

/** Saved customer health baselines of one organization. */
export const CustomerHealthBaselinesSchema =
  UpdateCustomerHealthBaselinesRequestSchema.extend({
    organizationId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
  });

export type CustomerHealthBaselines = z.infer<
  typeof CustomerHealthBaselinesSchema
>;
